export default "__VITE_ASSET__96YQV7Yx__"